/* eslint-disable */

/*
 * Tippy plugin to close tooltip on Escape press
 * Borrowed from https://atomiks.github.io/tippyjs/v6/plugins/
 */
const hideOnEsc = {
  name: "hideOnEsc",
  defaultValue: true,
  fn(instance) {
    function onKeyDown(event) {
      if (event.key === "Escape" || event.key == "Esc") {
        instance.props.onHide(instance);
      }
    }
    return {
      onShow() {
        document.addEventListener("keydown", onKeyDown);
      },
      onHide() {
        document.removeEventListener("keydown", onKeyDown);
      }
    };
  }
};

/*
 * Tippy plugin to close tooltip when trigger is blurred.
 *
 * This is for mimicking `trigger="focus"` of `tippy.js`.
 * The original `trigger="focus"` of `tippy.js` seems to make `<ToggleTooltip>` require
 * hitting enter/space twice to open it. (IFL-1026)
 *
 * We close the tooltip when the focus moves away from the trigger button
 * as part of such mimick with an exception;
 * We keep tooltip open when the focus moves to the tooltip content,
 * so user can copy/paste the content (IFL-1365).
 */
const hideOnBlur = {
  name: "hideOnBlur",
  defaultValue: true,
  fn(instance) {
    function onFocusOut(event) {
      if (!event.relatedTarget) {
        instance.hide();
      }
      if (event.relatedTarget instanceof Element && !instance.reference.contains(event.relatedTarget) && !instance.popper.contains(event.relatedTarget)) {
        instance.hide();
      }
    }
    return {
      onCreate() {
        document.addEventListener("focusout", onFocusOut);
      },
      onDestroy() {
        document.removeEventListener("focusout", onFocusOut);
      }
    };
  }
};

export { hideOnBlur, hideOnEsc };
